export const COMMUNITIES_PER_PAGE = 4
